import { Link } from "react-router-dom";
function Sidebar() {
    return<aside id="sidebar" className="sidebar">

    <ul className="sidebar-nav" id="sidebar-nav">

      <li className="nav-item">
        <Link className="nav-link " to="/">
          <i className="bi bi-grid"></i>
          <span>Dashboard</span>
        </Link>
      </li>

      <li className="nav-item">
        <Link className="nav-link collapsed" data-bs-target="#components-nav" data-bs-toggle="collapse" to="#">
          <i className="bi bi-menu-button-wide"></i><span>Services</span><i className="bi bi-chevron-down ms-auto"></i>
        </Link>
        <ul id="components-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
          <li>
            <Link to="/addCategory">
              <i className="bi bi-circle"></i><span> Service Category </span>
            </Link>
          </li>
          <li>
            <Link to="/addBrand">
              <i className="bi bi-circle"></i><span>Service Type</span>
            </Link>
          </li>
          <li>
            <Link to="/addProduct">
              <i className="bi bi-circle"></i><span>User List</span>
            </Link>
          </li>
          <li>
            <Link to="/OrderRequest">
              <i className="bi bi-circle"></i><span>Order Request</span>
            </Link>
          </li>
        </ul>
      </li>
     

      <li className="nav-item">
        <Link className="nav-link collapsed" to="/Profile">
          <i className="bi bi-person"></i>
          <span>Profile</span>
        </Link>
      </li>

    

      <li className="nav-item">
        <Link className="nav-link collapsed" to="/AdminContact">
          <i className="bi bi-envelope"></i>
          <span>Contact</span>
        </Link>
      </li>

  

      <li className="nav-item">
        <Link className="nav-link collapsed" to="/AdminLogin">
          <i className="bi bi-box-arrow-in-right"></i>
          <span>Login</span>
        </Link>
      </li>

     
    </ul>

  </aside>
  }
  
  export default Sidebar;
  /* "*/
  